"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var prosemirror_tables_1 = require("prosemirror-tables");
var const_1 = require("./const");
var utils_1 = require("./utils");
var table_context_menu_1 = require("./table-context-menu");
var core_utilities_1 = require("@syl-editor/core-utilities");
var KEY = new prosemirror_state_1.PluginKey('tableHelper');
var getCellPosInTable = function (table, anchorCell, headCell) {
    var anchor = 0;
    var head = 0;
    table.content.forEach(function (tableRow, offset) {
        if (anchor && head)
            return false;
        tableRow.content.forEach(function (tableCell, cellOffset) {
            if (tableCell === anchorCell)
                anchor = offset + cellOffset;
            else if (tableCell === headCell)
                head = offset + cellOffset;
        });
    });
    return {
        anchor: anchor,
        head: head
    };
};
var TableHelperPlugin = function (editor) {
    return new prosemirror_state_1.Plugin({
        key: KEY,
        view: function (view) { return new table_context_menu_1.TableContextMenu(editor, view); },
        props: {
            handleDOMEvents: {
                cut: function (view, event) {
                    var state = view.state, dispatch = view.dispatch;
                    var tr = state.tr;
                    if (utils_1.judgeSelectAllTable(view)) {
                        var $pos = state.selection.$anchor;
                        var node = $pos.node(1);
                        if (node.type.spec.tableRole === 'table') {
                            var from = $pos.before(1);
                            var to = $pos.after(1);
                            dispatch(tr.setSelection(core_utilities_1.TextSelection.create(tr.doc, from, to)));
                        }
                    }
                    return false;
                }
            },
            transformPastedHTML: function (html) {
                var metas = /(\s*<meta [^>]*>)*/.exec(html);
                var result = html;
                if (metas)
                    result = html.slice(metas[0].length);
                var $div = core_utilities_1.Utils.createDetachedElement('div');
                $div.innerHTML = result;
                if ($div.children.length === 1) {
                    var $context = $div.querySelector('[data-pm-slice]');
                    var sliceData = $context && /^(\d+) (\d+) (.*)/.exec($context.getAttribute('data-pm-slice') || '');
                    try {
                        // 当复制表格里面单个文字的时候，去除 data-pm-slice
                        if ($context &&
                            sliceData &&
                            sliceData[1] === sliceData[2] &&
                            sliceData[3].indexOf('["table",null,"table_row",null,') === 0) {
                            $context.removeAttribute('data-pm-slice');
                        }
                    }
                    catch (e) {
                        return html;
                    }
                }
                return $div.innerHTML;
            }
        },
        appendTransaction: function (trs, oldState, newState) {
            if (newState.selection instanceof prosemirror_tables_1.CellSelection || newState.selection instanceof prosemirror_state_1.AllSelection) {
                return;
            }
            var _a = newState.selection, $from = _a.$from, $to = _a.$to, empty = _a.empty;
            if (empty || !$from.depth || !$to.depth)
                return;
            var fromNode = $from.node(1);
            var toNode = $from.node(1);
            if (fromNode.type.name === const_1.NODE_NAME.TABLE && fromNode === toNode) {
                // 把表格中跨单元格选中的都转成cellSelection
                var fromCell = utils_1.closestCell($from);
                var toCell = utils_1.closestCell($to);
                if (!fromCell || !toCell || fromCell.node === toCell.node)
                    return;
                var _b = getCellPosInTable(fromNode, fromCell.node, toCell.node), anchor = _b.anchor, head = _b.head;
                var startPos = $from.before(1) + 2;
                return newState.tr.setSelection(prosemirror_tables_1.CellSelection.create(newState.doc, startPos + anchor, startPos + head));
            }
        }
    });
};
exports.TableHelperPlugin = TableHelperPlugin;
//# sourceMappingURL=table-helper.js.map